import { Chat } from '@mint-sdk/api-ai-assistant';

import {
  ROOT_FOLDER_ID,
  type FileNode,
  type FileSystemNode,
  type FolderNode,
} from '../types/fileSystem.js';

export const isFolderNode = (
  node?: FileSystemNode | null,
): node is FolderNode => node?.kind === 'folder';

export const getNodeName = (node: FileSystemNode) =>
  isFolderNode(node) ? node.name : node.fileName;

export const getNodeRowId = (node: FileSystemNode) =>
  `${node.kind}:${isFolderNode(node) ? node.id : node.fileId}`;

export const toFileNode = (document: Chat.RagDocumentType): FileNode => ({
  kind: 'file',
  id: document.fileId,
  fileId: document.fileId,
  fileName: document.filename,
  fileType: document.type,
  description: document.description,
  uploadedDate: document.createdAt,
  firstName: document.firstName,
  lastName: document.lastName,
  userId: document.userId,
  status: document.status,
});

export const getFileFolderId = (
  fileId: string,
  fileLocations: Record<string, string>,
) => fileLocations[fileId] ?? ROOT_FOLDER_ID;

export const getNodeParentId = (
  node: FileSystemNode,
  fileLocations: Record<string, string>,
) =>
  isFolderNode(node) ? node.parentId : getFileFolderId(node.id, fileLocations);

export const splitFileSystemNodes = <T extends FileSystemNode>(nodes: T[]) => {
  const folders = nodes.filter((node): node is Extract<T, FolderNode> =>
    isFolderNode(node),
  );

  const files = nodes.filter(
    (node): node is Extract<T, FileNode> => !isFolderNode(node),
  );

  return {
    folders,
    files,
    foldersCount: folders.length,
    filesCount: files.length,
  };
};
